export default __webpack_public_path__ + "static/media/Prison-3D-Model-08.c3dc0f93.jpg";